// 목록 화면 검색 영역 공통 카드.
// /chancemng 프로토타입(2026-10-22, fc30533)에서 추출. Paper(variant=outlined) 한 장 +
// form 그리드 + 끝단 초기화/검색 버튼 + 휴대폰에서는 MobileFilterCollapse로 접기까지를
// 여기서 담당한다. 그리드 안의 필드 개수·너비(gridTemplateAreas/Columns)는 화면마다 달라서
// 그 부분만 호출부가 `gridSx`로 넘긴다 - 각 필드 Box는 호출부가 직접 두고 `sx={{ gridArea: '...' }}`로
// 칸을 지정한다 (chancemng ChanceListBox.js 참고).
import React from 'react';
import { Box, Button, Paper } from '@mui/material';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import MobileFilterCollapse from '../form/MobileFilterCollapse';

// 검색 카드 안 TextField/Select 공통 속성 - outlined + size small로 통일.
export const fieldProps = {
  variant: 'outlined',
  size: 'small',
};

const SearchCard = ({
  summary,
  onSubmit,
  onReset,
  submitting = false,
  gridSx = {},
  btnsArea = 'btns',
  paperSx = {},
  resetLabel = '초기화',
  searchLabel = '검색',
  children,
}) => {
  return (
    <MobileFilterCollapse summary={summary}>
      <Paper
        variant="outlined"
        sx={{
          width: '100%',
          p: { xs: 1.5, sm: 2 },
          ...paperSx,
        }}
      >
        <Box
          component="form"
          noValidate
          autoComplete="off"
          onSubmit={onSubmit}
          sx={{
            display: 'grid',
            gap: { xs: 1.25, sm: 1.5 },
            alignItems: 'end',
            ...gridSx,
          }}
        >
          {children}

          <Box
            sx={{
              gridArea: btnsArea,
              display: 'flex',
              gap: 1,
              justifyContent: { xs: 'stretch', sm: 'flex-end' },
              flexWrap: 'nowrap',
              '& .MuiButton-root': {
                flex: { xs: 1, sm: 'initial' },
                minWidth: { xs: 0, sm: 88 },
              },
            }}
          >
            {onReset && (
              <Button
                type="button"
                variant="outlined"
                color="inherit"
                size="medium"
                startIcon={<RestartAltIcon fontSize="small" />}
                onClick={onReset}
                disabled={submitting}
                sx={{ whiteSpace: 'nowrap' }}
              >
                {resetLabel}
              </Button>
            )}
            <Button
              type="submit"
              variant="contained"
              color="info"
              size="medium"
              disabled={submitting}
              sx={{ whiteSpace: 'nowrap' }}
            >
              {searchLabel}
            </Button>
          </Box>
        </Box>
      </Paper>
    </MobileFilterCollapse>
  );
};

export default SearchCard;
